import styled from '@emotion/styled';
import { colors, fonts, layout } from './theme';

const DEFAULT_LOGOS = [
  { name: 'Under Armour', src: '/logo/clients/under-armour.png' },
  { name: 'Geely', src: '/logo/clients/geely.png' },
  { name: 'Budweiser', src: '/logo/clients/budweiser.png' },
  { name: 'Superbet', src: '/logo/clients/superbet.png' },
  { name: 'Vitality', src: '/logo/clients/vitality.png' },
  { name: 'Fever', src: '/logo/clients/fever.svg' },
];

const Root = styled.section`
  background: ${colors.baselineWhite};
  padding: clamp(48px, 6vw, 72px) 0 clamp(52px, 7vw, 80px);
`;

const Inner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
`;

const Eyebrow = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.textMuted};
  margin: 0 0 24px;
`;

const Card = styled.div`
  background: ${colors.baselineBlue};
  border: 1px solid ${colors.borderAccentLight};
  border-radius: 8px;
  padding: clamp(12px, 1.6vw, 20px);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: clamp(12px, 1.6vw, 20px);
`;

const LogoCell = styled.div`
  background: ${colors.baselineWhite};
  border-radius: 6px;
  padding: clamp(16px, 2.4vw, 28px) clamp(12px, 1.6vw, 20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImg = styled.img`
  height: clamp(28px, 3.2vw, 36px);
  width: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
`;

interface Logo {
  name: string;
  src: string;
}

interface LogoBarProps {
  logos?: Logo[];
}

export default function LogoBar({ logos = DEFAULT_LOGOS }: LogoBarProps) {
  return (
    <Root>
      <Inner>
        <Eyebrow>Advertisers buying, agencies planning it</Eyebrow>
        <Card>
          <Row>
            {logos.map((logo) => (
              <LogoCell key={logo.name}>
                <LogoImg src={logo.src} alt={logo.name} />
              </LogoCell>
            ))}
          </Row>
        </Card>
      </Inner>
    </Root>
  );
}
